import { resolveItemRecord } from '../row/item.row.record';

/**
 * "<action> · <item name>" for one row, "<action> · N items" for many — every item is equal in a bulk
 * op, so a count beats spotlighting an arbitrary first row.
 */
export function buildJobItemBulkActionTitle(action: string, rows: unknown[]): string {

  const count = rows?.length ?? 0;
  if (count !== 1) return `${action} · ${count} items`;

  return `${action} · ${resolveItemRecord(rows[0])?.name ?? 'item'}`;
}
